import { render, staticRenderFns } from "./QuoteProcessTable.vue?vue&type=template&id=6b4bfcb0&scoped=true&"
import script from "./QuoteProcessTable.vue?vue&type=script&lang=js&"
export * from "./QuoteProcessTable.vue?vue&type=script&lang=js&"
import style0 from "./QuoteProcessTable.vue?vue&type=style&index=0&id=6b4bfcb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4bfcb0",
  null
  
)

export default component.exports